import type { PageMetadata } from "@moment/api-collab/api-types";
import {
	getPageReferenceFragmentCandidates,
	parseLinkText,
	resolvePageReference,
} from "@moment/state";

export const getPageLinkAncestorPath = (
	page: PageMetadata | null | undefined,
	pages: PageMetadata[] | null | undefined
): string | null => {
	if (!page?.parentPageID || !pages) {
		return null;
	}

	const titles: string[] = [];
	const visitedPageIds = new Set<string>();
	let currentId: string | null = page.parentPageID;

	while (currentId && !visitedPageIds.has(currentId)) {
		visitedPageIds.add(currentId);
		const ancestor = pages.find((candidate) => candidate.id === currentId);
		if (!ancestor) {
			break;
		}

		titles.unshift(ancestor.title || "Untitled");
		currentId = ancestor.parentPageID;
	}

	return titles.length > 0 ? titles.join(" / ") : null;
};

export const getPageLinkFallbackDisplayTitle = (pageTitle: string): string =>
	parseLinkText(pageTitle).title;

export const getPageLinkCreateTitle = (
	pageTitle: string,
	pages: PageMetadata[],
	currentPageId?: string
): string => {
	const fallbackTitle = getPageLinkFallbackDisplayTitle(pageTitle);

	const resolvedReference = resolvePageReference(pageTitle, pages, currentPageId);
	if (!resolvedReference?.fragment) {
		const [candidate] = getPageReferenceFragmentCandidates(fallbackTitle);
		if (!candidate || /^\d+$/.test(candidate.fragment)) {
			return fallbackTitle;
		}

		return parseLinkText(candidate.basePageRef).title;
	}

	return resolvedReference.page.title;
};

export const getPageLinkResolvedDisplayTitle = (
	resolvedPageTitle: string,
	fragment?: string
): string => {
	if (!fragment) {
		return resolvedPageTitle;
	}

	return `${resolvedPageTitle}#${fragment}`;
};
